/*eslint-disable react/display-name*/
import React, { useRef, useState } from 'react';
import './style.scss';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SwiperSlide } from 'swiper/react/swiper-react.js';
import clsx from 'clsx';
import CarouselSlider from '../../../Shared/components/Carousel/shared/slider';

const TabsCarouselComponent = React.memo(
  ({ onTabClick, initialTabName, tabNames, className, lang }) => {
    const [active, setActive] = useState(initialTabName);
    const [nextVisible, setNextVisible] = useState(false);
    const [prevVisible, setPrevVisible] = useState(false);
    const controlsId = useRef(Math.round(Math.random() * 100000));
    const prevId = `tabs-car-control-prev-${controlsId.current}`;
    const nextId = `tabs-car-control-next-${controlsId.current}`;

    const handleSwap = (pagesAmount, isFirstSlide, isLastSlide) => {
      setNextVisible(pagesAmount > 1 && !isLastSlide);
      setPrevVisible(pagesAmount > 1 && !isFirstSlide);
    };

    const handleTabClick = (name) => {
      onTabClick(name);
      setActive(name);
    };

    return (
      <div className={clsx('tabs-carousel-wrapper', className)}>
        <div
          id={prevId}
          className={clsx(
            'tabs-carousel-control',
            'tabs-carousel-control-left',
            !prevVisible && 'tabs-carousel-control-hidden'
          )}
        >
          <div />
        </div>
        <CarouselSlider
          onSlideSwap={handleSwap}
          className="tabs-carousel"
          prevControlId={prevId}
          nextControlId={nextId}
          slidesPerView="auto"
          spaceBetween={0}
          lang={lang}
        >
          {tabNames?.map((tabName, index) => (
            <SwiperSlide
              key={index}
              className={clsx(
                'tabs-carousel-tab',
                active.id === tabName.id && 'tabs-carousel-tab-active'
              )}
              onClick={() => handleTabClick(tabName)}
            >
              <Text field={{ value: tabName.name }} />
            </SwiperSlide>
          ))}
        </CarouselSlider>
        <div
          id={nextId}
          className={clsx(
            'tabs-carousel-control',
            'tabs-carousel-control-right',
            !nextVisible && 'tabs-carousel-control-hidden'
          )}
        >
          <div />
        </div>
      </div>
    );
  },
  () => true
);

export default TabsCarouselComponent;
